import api from "./api";

export async function fetchQuizSeriesList(params = {}, endpoint = "/quiz/quiz-series-list") {
  const response = await api.get(endpoint, {
    params,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function fetchSeriesQuizList(params = {}) {
  const response = await api.get("/quiz/quiz-list", {
    params,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}
